import React from "react";
import QueueProGate from "../../components/QueueProGate";
import QueuedOrders from "../../components/QueuedOrders";
import { cashierAxios } from "../../axiosInstance";

function QueuedOrdersModal({ onClose, currency }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white text-black rounded-lg w-full max-w-5xl mx-4 max-h-[90vh] overflow-y-auto p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-3xl text-gray-400 hover:text-red-500"
          title="Close"
        >
          ×
        </button>
        <h2 className="text-xl font-semibold mb-4">Queue</h2>
        <QueueProGate api={cashierAxios} role="cashier" onClose={onClose}>
          <QueuedOrders
            api={cashierAxios}
            role="cashier"
            currency={currency}
            bare
          />
        </QueueProGate>
      </div>
    </div>
  );
}

export default QueuedOrdersModal;
